import Image from 'next/future/image';
import certified from '@/public/icons/product/certifiedAqua.svg';

function BrandBadge() {
  return (
    <div className="flex items-center gap-1.5 rounded-md bg-[#F5FFFF] px-3 py-1.5 text-xs text-[#497B7D]">
      <div className="h-3.5 w-3.5 shrink-0">
        <Image
          alt="Direct from brand"
          src={certified}
          className="h-full w-full"
        />
      </div>
      Direct from brand
    </div>
  );
}

export default BrandBadge;
